import React from "react";

export default function Search({
  width = "40",
  height = "42",
  stroke = "#606f7b",
  fill = "#f8fafc"
}) {
  return (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 40 42"
      width={width}
      height={height}
    >
      <g id="Canvas" fill="none">
        <g id="searchVektor">
          <g id="Vector">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M 34.0702 18.8219L 34.0703 18.8201C 34.4929 14.3837 33.0855 10.0135 30.1911 6.55438C 27.2993 3.0983 23.2825 0.983638 18.7675 0.559777C 9.60055 -0.214643 1.35223 6.62796 0.577045 15.8597L 0.576577 15.8653L 0.576546 15.8653C 0.153597 20.3063 1.49182 24.6743 4.38128 28.1288C 7.34761 31.5883 11.3663 33.702 15.8796 34.1256C 25.0431 34.8997 33.2239 28.06 34.0702 18.8219ZM 26.3884 9.83905L 26.3883 9.83911C 28.3538 12.2582 29.3432 15.2917 29.0392 18.4078C 28.7363 21.5122 27.2954 24.3193 24.8705 26.3653C 22.4499 28.4077 19.3408 29.399 16.2225 29.0223C 13.0347 28.7912 10.2308 27.2699 8.19192 24.8534L 8.18594 24.8463L 8.18601 24.8463C 6.22126 22.4281 5.2319 19.3961 5.53475 16.2814C 6.06809 9.83034 11.8324 5.05967 18.3446 5.66256C 21.5354 5.89195 24.342 7.41369 26.3824 9.83197L 26.3884 9.83905Z"
              transform="translate(5.35596 0)"
              fill={fill}
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M 34.0702 18.8219L 34.0703 18.8201C 34.4929 14.3837 33.0855 10.0135 30.1911 6.55438C 27.2993 3.0983 23.2825 0.983638 18.7675 0.559777C 9.60055 -0.214643 1.35223 6.62796 0.577045 15.8597L 0.576577 15.8653L 0.576546 15.8653C 0.153597 20.3063 1.49182 24.6743 4.38128 28.1288C 7.34761 31.5883 11.3663 33.702 15.8796 34.1256C 25.0431 34.8997 33.2239 28.06 34.0702 18.8219ZM 26.3884 9.83905L 26.3883 9.83911C 28.3538 12.2582 29.3432 15.2917 29.0392 18.4078C 28.7363 21.5122 27.2954 24.3193 24.8705 26.3653C 22.4499 28.4077 19.3408 29.399 16.2225 29.0223C 13.0347 28.7912 10.2308 27.2699 8.19192 24.8534L 8.18594 24.8463L 8.18601 24.8463C 6.22126 22.4281 5.2319 19.3961 5.53475 16.2814C 6.06809 9.83034 11.8324 5.05967 18.3446 5.66256C 21.5354 5.89195 24.342 7.41369 26.3824 9.83197L 26.3884 9.83905Z"
              strokeMiterlimit="8"
              transform="translate(5.35596 0)"
              stroke={stroke}
            />
          </g>
          <g id="Vector_2">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M 1.43173 10.5805C 0.273139 11.7391 0.218622 13.3798 1.1413 14.3025C 2.06398 15.2252 3.70476 15.1707 4.86335 14.0121L 14.0121 4.86334C 15.1707 3.70474 15.2252 2.06396 14.3025 1.14129C 13.3799 0.218613 11.7391 0.273143 10.5805 1.43174L 10.2348 1.08604L 10.5805 1.43174L 1.43173 10.5805Z"
              transform="translate(0 25.8489)"
              fill={fill}
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M 1.43173 10.5805C 0.273139 11.7391 0.218622 13.3798 1.1413 14.3025C 2.06398 15.2252 3.70476 15.1707 4.86335 14.0121L 14.0121 4.86334C 15.1707 3.70474 15.2252 2.06396 14.3025 1.14129C 13.3799 0.218613 11.7391 0.273143 10.5805 1.43174L 10.2348 1.08604L 10.5805 1.43174L 1.43173 10.5805Z"
              strokeMiterlimit="8"
              transform="translate(0 25.8489)"
              stroke={stroke}
            />
          </g>
        </g>
      </g>
    </svg>
  );
}



// WEBPACK FOOTER //
// ./src/Icons/Search.js